module.exports = __webpack_public_path__ + "cbc8cb16a2b8f14ff24b04fc109e0d99.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/images/browser_firefox.png
// module id = 370
// module chunks = 1